import Axios from "axios";
import Firebase from "firebase";
import moment from "moment";

const EventInfoStore = {
  namespaced: true,
  debug: true,
  state: {
    eventInfoList: [],
    allEventInfoList: [],
    eventInfoDetail: []
  },
  mutations: {
    setEventInfoList(state, data) {
      state.eventInfoList = data;
    },
    setAllEventInfoList(state, data) {
      state.allEventInfoList = data;
    },
    setEventInfoDetail(state, data) {
      state.eventInfoDetail = data;
    }
  },
  getters: {
    getEventInfoList(state) {
      return state.eventInfoList;
    },
    getAllEventInfoList(state) {
      return state.allEventInfoList.map(val => {
        let result = {
          EventId: val.eventid,
          Subject: val.subject,
          StartDate: moment(val.startdate).format("YYYY/MM/DD"),
          EndDate: moment(val.enddate).format("YYYY/MM/DD")
        };
        return result;
      });
    },
    getEventInfoDetail(state) {
      return state.eventInfoDetail;
    }
  },
  actions: {
    async callApiEventList({ commit }) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let eventInfoList = await Axios.post(
            process.env.VUE_APP_API_URL + "api/user/eventList",
            "",
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setEventInfoList", eventInfoList.data);
        })
        .catch(function() {
          // Handle error
        });
    },

    async callApiAllEventList({ commit }) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let allEventInfoList = await Axios.post(
            process.env.VUE_APP_API_URL + "api/user/allEventList",
            "",
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setAllEventInfoList", allEventInfoList.data);
        })
        .catch(function() {
          // Handle error
        });
    },

    async callApiEventDetail({ commit }, eventId) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let eventInfoDetail = await Axios.post(
            process.env.VUE_APP_API_URL + "api/user/eventDetail",
            {
              EventId: eventId
            },
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setEventInfoDetail", eventInfoDetail.data[0]);
        })
        .catch(function() {
          // Handle error
        });
    }
  }
};
export default EventInfoStore;
